import { render, staticRenderFns } from "./dal-comp-development.vue?vue&type=template&id=377946ff"
import script from "./dal-comp-development.vue?vue&type=script&lang=js"
export * from "./dal-comp-development.vue?vue&type=script&lang=js"
import style0 from "./dal-comp-development.vue?vue&type=style&index=0&id=377946ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports